<div class="session-handoff">
  <div class="session-handoff__header">
    <h1 class="session-handoff__page-title">{{ pageTitle() }}</h1>
  </div>

  <div class="session-handoff__message">
    @if(!!cardTitle()){
    <h2 class="session-handoff__message__title">{{ cardTitle() }}</h2>
    }
    <p class="session-handoff__message__text">{{ cardMessage() }}</p>
  </div>

  <div
    class="session-handoff__participants"
    [class.session-handoff__participants--slim]="participants().length > 3"
    [class.session-handoff__participants--single]="participants().length === 1"
  >
    @for (participant of participants(); track participant.packageUserGuid) {
      <app-participant-card
        [participant]="participant"
        [associatedUsers]="associatedUsers()"
        [usersInWaitingRoom]="usersInWaitingRoom()"
        (joinSession)="onJoinSession($event)"
      >
      </app-participant-card>
    }
  </div>
</div>